var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKettle = function SvgKettle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path976",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m40.19 57.688 44.993-8.685c57.73 7.614 102.48 3.212 128.43-18.798l29.162-2.736c34.4-3.45 58.087 6.186 69.871 30.219 12.022 30.933 21.544 63.412 23.33 100.77.595 21.534-2.976 41.64-17.497 58.177-2.142 5.948-59.396 40.093-55.706 71.264l-.119 21.415H52.564c-3.69-75.904-.714-139.08 8.451-190.12-9.76-20.463-15.95-41.045-20.83-61.508zm116.65 37.714c12.617 0 22.973 10.232 22.973 22.843v133.01c0 12.492-10.356 22.843-22.973 22.843-12.498 0-22.854-10.351-22.854-22.843v-133.01c0-12.611 10.356-22.843 22.854-22.843m82.012-28.553c17.616 38.785 24.639 91.727 24.996 153.83 10.594-5.235 32.971-29.981 34.757-34.978 10.118-14.99 3.214-92.798-20.83-120.88-12.617-10.588-25.71-7.733-38.923 2.023z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path978",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M88.635 41.27c48.683 7.733 89.868 3.45 121.29-16.894C168.741-6.2 109.105 7.125 88.635 41.27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path980",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M262.66 317.16H52.57c1.666 16.537 9.522 27.482 26.901 30.1h153.79c16.783-.833 27.139-10.232 29.4-30.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path982",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M146.96 125.62h19.997c2.857 0 5.237 2.38 5.237 5.235 0 2.974-2.38 5.354-5.237 5.354H146.96c-2.857 0-5.237-2.38-5.237-5.354 0-2.855 2.38-5.235 5.237-5.235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path984",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M146.96 151.44h19.997c2.857 0 5.237 2.38 5.237 5.235s-2.38 5.235-5.237 5.235H146.96c-2.857 0-5.237-2.38-5.237-5.235s2.38-5.235 5.237-5.235"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path986",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M146.96 177.37h19.997c2.857 0 5.237 2.38 5.237 5.235 0 2.974-2.38 5.354-5.237 5.354H146.96c-2.857 0-5.237-2.38-5.237-5.354 0-2.855 2.38-5.235 5.237-5.235"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path988",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M146.96 203.55h19.997c2.857 0 5.237 2.38 5.237 5.235s-2.38 5.235-5.237 5.235H146.96c-2.857 0-5.237-2.38-5.237-5.235s2.38-5.235 5.237-5.235"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path990",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M146.96 229.48h19.997c2.857 0 5.237 2.38 5.237 5.235 0 2.974-2.38 5.353-5.237 5.353H146.96c-2.857 0-5.237-2.379-5.237-5.353 0-2.856 2.38-5.235 5.237-5.235"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKettle);
export default ForwardRef;